"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModal = void 0;
const bootstrap = require("bootstrap");
const query_1 = require("./query");
class AppModal {
    static getInstance(selector) {
        let match = query_1.Z.one(selector);
        if (match) {
            let data = query_1.Z.getData(match, 'app-modal');
            if (data)
                return data;
        }
        return null;
    }
    get isAsync() {
        return this.container && this.container.matches('.async-modals .modal');
    }
    constructor(container) {
        this.afterShownCallback = null;
        this.container = container;
        this.bsModal = bootstrap.Modal.getOrCreateInstance(this.container);
        this.container.addEventListener('hide.bs.modal', ev => this.onHide(ev));
        this.container.addEventListener('hidden.bs.modal', ev => this.onHidden(ev));
        this.container.addEventListener('hidePrevented.bs.modal', ev => this.onHidePrevented(ev));
        this.container.addEventListener('show.bs.modal', ev => this.onShow(ev));
        this.container.addEventListener('shown.bs.modal', ev => this.onShown(ev));
        //let bsModal = this.bsModal;
    }
    static init() {
        query_1.Z.init('.modal', 'app-modals', el => {
            query_1.Z.setData(el, 'app-modal', new AppModal(el));
        });
        query_1.Z.init('[data-modal]', 'show-modal-trigger', el => {
            el.addEventListener('click', ev => {
                let selector = el.dataset.modal;
                AppModal.showModal(selector, () => {
                    if (el.dataset.afterModal) {
                        if (el.dataset.afterModal.startsWith('js:')) {
                            eval(el.dataset.afterModal.substring('js:'.length));
                        }
                    }
                }, el);
            });
        });
        query_1.Z.init('#confirmation-dialog', 'confirmation-dialog', modal => {
            query_1.Z.forEachFrom(modal, '.modal-footer .cancel-button', btn => {
                btn.addEventListener('click', ev => query_1.Z.confirmationDialogCancelled());
            });
            query_1.Z.forEachFrom(modal, '.modal-footer .approve-button', btn => {
                btn.addEventListener('click', ev => query_1.Z.confirmationDialogApproved());
            });
        });
    }
    static showModal(selector, andThen = null, src = null, afterShown = null) {
        //console.log(`showModal`, selector, andThen, src);
        if (selector.startsWith('/')) {
            query_1.Z.spinUp(src);
            fetch(selector)
                .then(resp => {
                query_1.Z.spinDown();
                if (resp.ok) {
                    resp.text()
                        .then(html => {
                        query_1.Z.forEach('.async-modals', container => {
                            let dom = query_1.Z.parseHtmlAsTemplate(html);
                            container.appendChild(dom);
                            query_1.Z.updateLayout();
                            let asyncModals = query_1.Z.selectFrom(container, '.modal');
                            if (asyncModals.length) {
                                let newModalDom = asyncModals[asyncModals.length - 1];
                                let newModal = new AppModal(newModalDom);
                                if (afterShown != null)
                                    newModal.afterShownCallback = afterShown;
                                query_1.Z.setData(newModalDom, 'app-modal', newModal);
                                newModal.bsModal.show();
                                if (andThen)
                                    andThen(newModal.container, newModal);
                            }
                        });
                    });
                }
            });
        }
        else {
            query_1.Z.forEach(selector, el => {
                if (el.matches('.modal')) {
                    let modat = query_1.Z.getData(el, 'app-modal');
                    if (modat && modat.bsModal) {
                        modat.bsModal.show();
                    }
                }
            });
        }
    }
    onHide(ev) {
    }
    onHidden(ev) {
        if (this.isAsync)
            this.container.remove();
    }
    onHidePrevented(ev) {
    }
    onShown(ev) {
        query_1.Z.forFirstFrom(this.container, '.focus-on-modal', el => {
            if (el.focus)
                el.focus();
            if (el.select)
                el.select();
        });
        if (this.afterShownCallback)
            this.afterShownCallback(this.container);
    }
    onShow(ev) {
        query_1.Z.forEach('.context-menu.active', mi => mi.classList.remove('active'));
    }
}
exports.AppModal = AppModal;
//# sourceMappingURL=appModals.js.map